import { jsx as _jsx } from "react/jsx-runtime";
import { ComponentSync, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import { PermissionKeysEditor } from './subEditors/permission-keys-editor.js';
import { ModuleFE_PermissionAccessLevel } from '../../_entity.js';
export class ATS_ComponentPermissionKeys extends ComponentSync {
    static screen = {
        key: 'component-permission-keys',
        name: 'Component Permission Keys',
        renderer: this,
        group: 'Permissions',
        modulesToAwait: [ModuleFE_PermissionAccessLevel],
    };
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state ??= (this.state ? { ...this.state } : {});
        return state;
    }
    //######################### Render #########################
    render() {
        return _jsx(LL_V_L, { className: '', children: _jsx(PermissionKeysEditor, {}) });
    }
}
//# sourceMappingURL=ATS_ComponentPermissionKeys.js.map